module.exports = __webpack_public_path__ + "static/media/pagination-last.aa6990a0.svg";